import {
    AnalyzingData,
    SelectOptions,
    ConfirmWorks,
    ConfirmChannels,
    SelectPeriod,
    SetUp,
    UploadDetections,
} from './components/steps';

export const modalWidth = 1000;
export const modalHeight = 700;
export const progressBarHeight = 54;
export const progressBarWidth = 800;
export const stepContentHeight = 450;
export const contentWidth = 900;

export const componentMap: GapAnalysisComponentMap = {
    analyzingData: AnalyzingData,
    selectOptions: SelectOptions,
    confirmWorks: ConfirmWorks,
    confirmChannels: ConfirmChannels,
    selectPeriod: SelectPeriod,
    setUp: SetUp,
    uploadDetections: UploadDetections,
};

export const dataSourceLocaleStringOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
};
